import React, { HTMLAttributes, useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { SelectField } from 'scorer-ui-kit';

const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 100%;
  height: fit-content;
  margin-right: 10px;
  white-space: nowrap;
`;

const SelectFieldContainer  = styled.div`
  display: flex;
  position: relative;
  select{
    background-color: #fff;
  }
  label{
    margin-bottom: 0;
    font-size: 12px;
  }
  label > div> div {
    top: 50% !important;
    transform: translateY(-45%);
  }
`;

const PageLabel = styled.label<{ active: boolean }>`
  padding:0 10px 0 10px;
  margin-top: 5px;
  font-family: ${({ theme }) => theme.fontFamily.ui };;
  font-size: 12px;
  font-weight: 500;
  color: #a4adb5;
  cursor: pointer;
  pointer-events: ${({ active }) => active ? 'auto' : 'none'};
`;

const PageSizeContainer = styled.div`
  display: flex;
  margin-right: 28px;
`;

interface OwnProps {
  totalPages: number,
  pageSizeOptions?: number[],
  defaultPage?: number,
  defaultPageSize: number,
  onPageSizeChange: (size: number) => void,
  onPageChange: (page: number) => void,
  pageSizeText?: string,
  prevPageText?: string,
  nextPageText?: string,
  firstPageText?: string,
  lastPageText?: string
}

type Props = OwnProps & HTMLAttributes<HTMLDivElement>

const Pagination: React.FC<Props> = (props) => {
  const {
    pageSizeOptions = [10, 20, 30, 50, 100],
    defaultPageSize = 10,
    defaultPage = 1,
    pageSizeText = 'Items Per Page',
    prevPageText,
    nextPageText,
    lastPageText,
    totalPages,
    onPageSizeChange,
    onPageChange
  } = props;
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [activePage, setActivePage] = useState(defaultPage);

  useEffect(() => {
    setPageSize(defaultPageSize);
  }, [defaultPageSize]);
  
  useEffect(() => {
    setActivePage(defaultPage);
  }, [defaultPage]);

  const handlePageSizeChange = useCallback((event:string)=> {
    onPageSizeChange(Number(event));
  },[onPageSizeChange]);
  
  const handlePageChange = (value: number) => {
    onPageChange(value);
  };

  return (
    totalPages ?
      <PaginationContainer>
        {
          pageSizeOptions &&
            <PageSizeContainer>
              <SelectFieldContainer>
                <SelectField
                  changeCallback={handlePageSizeChange}
                  defaultValue={pageSize}
                  label={{
                    htmlFor: pageSizeText,
                    text: pageSizeText,
                    isSameRow: true
                  }}
                  isCompact
                >
                  {
                    pageSizeOptions.map((size: number, index: number) => <option key={index} value={size}>{size}</option>)
                  }
                </SelectField>
              </SelectFieldContainer>
            </PageSizeContainer>
        }
        <SelectFieldContainer>
          <SelectField
            changeCallback={(event) => handlePageChange(parseInt(event))}
            defaultValue={activePage}
            label={{
              htmlFor: prevPageText ?? '',
              text: prevPageText ?? '',
              isSameRow: true
            }}
            isCompact
          >
            {
              Array.from(Array(totalPages), (e, i) => 
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              )
            }
          </SelectField>
        </SelectFieldContainer>
        {
          nextPageText &&
            <PageLabel onClick={() => handlePageChange(activePage + 1)} active={activePage !== totalPages}>{nextPageText}</PageLabel>
        }
        {
          lastPageText &&
            <PageLabel onClick={() => handlePageChange(totalPages)} active={activePage !== totalPages}>{lastPageText}</PageLabel>
        }
      </PaginationContainer>
      : null
  );
};

export default Pagination;
